import { useTranslations } from "@/i18n/LocaleProvider";

export default function PaymentStep({
  bookingReference,
  loading,
  onPay,
}: {
  bookingReference: string;
  loading: boolean;
  onPay: () => void;
}) {
  const { t } = useTranslations();
  return (
    <div className="mt-8 space-y-4">
      <p>
        {t("book.payment.noticeBefore")} <strong>{bookingReference}</strong>
        {t("book.payment.noticeAfter")}
      </p>
      <button
        onClick={onPay}
        disabled={loading}
        className="rounded-xl bg-accent px-6 py-3 font-semibold text-accent-foreground disabled:opacity-50"
      >
        {loading ? t("book.payment.payLoading") : t("book.payment.payIdle")}
      </button>
    </div>
  );
}
